export const isWebviewSelector = (state) => state.appSettings.isWebview;
